import { SVGProps, Ref, forwardRef } from "react";

const ComponentHybridElectricIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 28 28"
    fill="currentColor"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Component Hybrid Electric Icon"
    {...props}
  >
    <title id="Component Hybrid Electric Icon">Component Hybrid Electric Icon</title>
    <path d="M19.834 11.268a.382.382 0 0 0-.536 0c-.192.19-4.665 4.639-4.665 8.123 0 2.68 2.214 4.862 4.934 4.862S24.5 22.072 24.5 19.39c0-3.496-4.473-7.936-4.666-8.123Zm-.268 10.761c-1.464 0-2.656-1.163-2.656-2.594 0-.34.284-.617.632-.617.35 0 .633.277.633.617 0 .75.624 1.36 1.391 1.36.35 0 .633.276.633.617 0 .34-.284.617-.633.617ZM6.975 12.394H3.88a.383.383 0 0 1-.349-.222.362.362 0 0 1 .072-.4l7.59-7.906a.39.39 0 0 1 .445-.08c.15.072.234.233.205.393l-.939 5.497H14c.152 0 .289.09.35.222a.362.362 0 0 1-.072.4l-7.59 7.907a.383.383 0 0 1-.443.076.366.366 0 0 1-.204-.393l.934-5.494Zm15.121-7.906L6.916 24.253a.63.63 0 0 1-.506.247.638.638 0 0 1-.38-.123.609.609 0 0 1-.126-.865l15.18-19.765a.643.643 0 0 1 .886-.124.61.61 0 0 1 .126.865Z" />
  </svg>
);

const ForwardRef = forwardRef(ComponentHybridElectricIcon);
export default ForwardRef;
